import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.repository.title',
		defaultMessage: 'Repository',
		description: '',
	},
	description: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.repository.description',
		defaultMessage:
			'Add a Bitbucket or GitHub repository to show information about branches, commits and pull requests in Jira issues.',
		description: '',
	},
	descriptionIssueTermRefresh: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.repository.description-issue-term-refresh',
		defaultMessage:
			'Add a Bitbucket or GitHub repository to show information about branches, commits and pull requests in Jira work items.',
		description: '',
	},
});
